<template>
  <CustomPage title="发票信息">
    <div slot="content" class="content">
      <Form ref="form" readonly>
        <Field
          v-model="form.companyName"
          label="单位全称"
          placeholder="请输入单位全称"
          :rules="[{ required: true, message: '' }]"
          input-align="right"
        />
        <Field
          v-model="form.taxpayerNumber"
          label="单位税号"
          placeholder="请输入单位税号"
          error-message-align="right"
          input-align="right"
        />
        <Field
          v-model="form.companyPhone"
          label="注册电话"
          placeholder="请输入注册电话"
          input-align="right"
        />
        <Field
          v-model="form.companyAddress"
          label="注册地址"
          placeholder="请输入注册地址"
          input-align="right"
        />
        <Field
          v-model="form.bankNo"
          label="银行账号"
          placeholder="请输入银行账号"
          error-message-align="right"
          input-align="right"
        />
        <Field
          v-model="form.bankName"
          label="开户银行"
          placeholder="请输入开户银行"
          input-align="right"
        />
        <div class="label">营业执照复印件</div>
        <Field class="field-uploader">
          <template #input>
            <div class="flex-shrink-0" style="height: 80px; width: 80px">
              <img
                class="w-full h-full"
                :src="form.businessLicenceImg"
                alt=""
              />
            </div>

            <div class="tip">
              仅支持jpg、jpeg、png、gif文件，仅限上传1张，大小不超过5M
            </div>
          </template>
        </Field>
        <div class="label">一般纳税人认证资格复印件</div>
        <Field
          class="field-uploader"
          :rules="[{ required: true, message: ' 请选择图片' }]"
        >
          <template #input>
            <div class="flex-shrink-0" style="height: 80px; width: 80px">
              <img
                class="w-full h-full"
                :src="form.taxpayerIdentificationImg"
                alt=""
              />
            </div>

            <div class="tip">
              仅支持jpg、jpeg、png、gif文件，仅限上传1张，大小不超过5M
            </div>
          </template>
        </Field>
      </Form>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Form, Field } from "vant";
export default {
  components: { CustomPage, Form, Field },
  data() {
    return {
      form: this.$route.query,
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  .tips {
    font-size: 28px;
    line-height: 40px;
    padding: 12px 24px;
    color: #2f2f2f;
    background-color: #cecece;
    text-align: center;
    &.red {
      color: #ff0000;
      background-color: #ffc6c6;
    }
  }
  .label {
    font-size: 28px;
    line-height: 1em;
    padding: 28px 24px 0;
  }
  .tip {
    font-size: 22px;
    color: #cecece;
    line-height: 32px;
  }
  .van-form {
    .van-cell {
      font-size: 28px;
      line-height: 1em;
      padding: 28px 24px;
      /deep/ .van-field__label {
        color: #333333;
      }
      /deep/ .van-field__value .van-field__control--custom {
        align-items: flex-end;
        .van-uploader__upload,
        .van-uploader__preview {
          margin-bottom: 0;
          margin-right: 24px;
        }
      }
      &::after {
        border-color: #f2f2f2;
      }
    }
    .field-uploader {
      padding-top: 16px;
    }
  }
  .bottom {
    padding: 50px 40px 0;
    .btn {
      margin-bottom: 80px;
      line-height: 68px;
      font-size: 28px;
      text-align: center;
      color: #fff;
      background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
      border-radius: 38px;
      border: 2px solid #fe6979;
      &.disable {
        background: #d6d6d6;
        border: #d6d6d6;
      }
    }
  }
}
</style>